module.exports = __webpack_public_path__ + "afe4951c4957a47a9c8c6cd7fc4d4d5a.pdf";